import React, { useRef, memo, useMemo } from 'react';
import PlateIngredientRenderer from 'components/plateviewer/render/plate/plateviewer/designview/PlateIngredientRenderer';
import { DisplayMode } from 'components/Experiment/constants';
import { WithCanvasContainerProps } from './withCanvasContainer';

interface Props extends WithCanvasContainerProps {
  displayMode: DisplayMode;
  highlightedWellNumbers?: number[];
}

const WellVirtualPlateWithIngredients = (props: Props) => {
  const ingredientGroupRef = useRef();
  const {
    containerRows,
    containerCols,
    plateHeight,
    plateWidth,
    wellRects,
    wellRectsPadded,
    wellWithIngredients,
    canvasRefs,
    displayMode,
    searchResult,
    highlightedWellNumbers,
  } = props;

  const _wellWithIngredients = useMemo(() => {
    return searchResult.rows.items.map((w) => {
      return wellWithIngredients.find((x) =>
        x.dropList.some((d) => d.dropId == w.__WellDropID),
      );
    });
  }, [searchResult.rows.items, wellWithIngredients]);

  return (
    <PlateIngredientRenderer
      ingredientsWells={_wellWithIngredients}
      wellRects={wellRects}
      wellRectsPadded={wellRectsPadded}
      width={plateWidth}
      height={plateHeight}
      rows={containerRows}
      cols={containerCols}
      displayMode={displayMode}
      canvasRefs={() => canvasRefs}
      grpRef={ingredientGroupRef.current}
      maxLengthOfPlate={searchResult.rows.pagination.total - 1}
      dropNumber={1} //SNF:RFR: We need to confirm if we always need to pass drop number 1, this will change when we pass all drops in welllist.
      shouldCacheLayer
      layerCachePixelRatio={displayMode === DisplayMode.WELLINGREDIENT ? 2.5 : 1}
      platePosition={{ colPos: 1, rowPos: 1 }}
      strokeNormalizer={1}
      highlightedWellNumbers={highlightedWellNumbers}
    />
  );
};

export default memo(WellVirtualPlateWithIngredients);
